import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { AppContextProvider } from '../../../AppLoader';
import { ResendVerificationCode } from '../../ResendVerificationCode';

/**
 * The SMS "resend code" control, wired to `add2FAPhoneStore`. Shared by the old
 * ConfirmCodeStep (link) and the redesign (secondary button).
 */
export const SmsResendCode: React.FC<{ showAsButton?: boolean }> = observer(
  ({ showAsButton }) => {
    const {
      rootStore: {
        postLoginStore: {
          premiumUsers2FaEnforcementStore: { add2FAPhoneStore: store },
        },
      },
    } = useContext(AppContextProvider);
    return (
      <ResendVerificationCode
        sendConfirmationCode={store.onResendVerificationSms}
        resendSuccessfullyIndication={store.resendSuccessfullyIndication}
        resendThrottleTimerValue={store.resendThrottleTimerValue}
        resendErrorMessage={store.resendErrorMessage}
        resendButtonSize="small"
        resendIndicationTranslationKey="code.resend.indication"
        showAsButton={showAsButton}
        variant={showAsButton ? 'themed' : undefined}
      />
    );
  },
);
